module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABBCAYAAABYUhMgAAAACXBIWXMAAAsSAAALEgHS3X78AAAA8ElEQVR4nO3csWkDQRBA0ZFRosylKHHslhyqDJWgUtTZmQXXsN9w73Uwn2XhYPYut6/HfWY+h62uM/OcmW/Z9/o407D/ifAR4SPCR4SPCB8RPiJ8RPiI8JHLcRynHLzmxEeEjwgfET4ifET4iPAR4SPCR4SPCB8RPiJ8RPjIWuF72yTbz4mPCB8RPiJ8RPiI8BHhI8JHhI8IH1mPz368+tvPCl/EVRMRPiJ8RPiI8BHhI8JHhI8IHxE+InxE+IjwkbVJtv5Jdj/l9KHrX3QrfJu5aiLCR4SPCB8RPiJ8RPiI8BHhI+vL9TUz71NOX5mZXzobDb/hHyrEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav_menu.png
// module id = 1253
// module chunks = 169